module.exports = __webpack_public_path__ + "static/media/aplicativoNotificacao.afd18e7a.svg";